import { normalizeLocale, type SupportedLocale } from '@/i18n/config';

export type SignUpAliasCopy = {
  plusAliasNotSupported: string;
};

// Sign-up rejects `+` aliases instead of silently stripping them (#4374).
const PLUS_ALIAS_NOT_SUPPORTED: Record<SupportedLocale, string> = {
  en: 'Email addresses with a "+" alias aren\'t supported. Use your address without the "+" part.',
  'pt-BR':
    'Endereços com alias "+" não são aceitos. Use seu e-mail sem a parte com "+".',
  ar: 'عناوين البريد التي تحتوي على اسم مستعار بعلامة "+" غير مدعومة. استخدم عنوانك بدون الجزء الذي يحتوي على "+".',
  es: 'No se admiten direcciones con alias "+". Usa tu correo sin la parte con "+".',
  fr: 'Les adresses avec un alias « + » ne sont pas prises en charge. Utilisez votre adresse sans la partie « + ».',
  it: 'Gli indirizzi con alias "+" non sono supportati. Usa il tuo indirizzo senza la parte con "+".',
  ko: '"+" 별칭이 포함된 이메일 주소는 지원되지 않습니다. "+" 부분을 뺀 주소를 사용해 주세요.',
  de: 'E-Mail-Adressen mit „+“-Alias werden nicht unterstützt. Verwende deine Adresse ohne den „+“-Teil.',
  ja: '「+」エイリアスを含むメールアドレスはご利用いただけません。「+」以降を除いたアドレスを入力してください。',
  hi: '"+" उपनाम वाले ईमेल पते समर्थित नहीं हैं। "+" वाले हिस्से के बिना अपना पता इस्तेमाल करें।',
  ru: 'Адреса с псевдонимом «+» не поддерживаются. Укажите адрес без части с «+».',
  zh: '不支持带有"+"别名的邮箱地址。请使用不含"+"部分的地址。',
  'zh-TW': '不支援含有「+」別名的電子郵件地址。請使用不含「+」部分的地址。',
  vi: 'Không hỗ trợ địa chỉ email có bí danh "+". Hãy dùng địa chỉ không có phần "+".',
  id: 'Alamat email dengan alias "+" tidak didukung. Gunakan alamat tanpa bagian "+".',
};

export function getSignUpAliasCopy(locale: string): SignUpAliasCopy {
  return {
    plusAliasNotSupported:
      PLUS_ALIAS_NOT_SUPPORTED[normalizeLocale(locale)] ??
      PLUS_ALIAS_NOT_SUPPORTED.en,
  };
}
